import types from './types';

const initialState = {
  activeInterface: {
    interface_items: [],
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.CLEAR_UNBOUNCE_INTERFACES_STATE:
      return initialState;

    case types.GET_NEW_UNBOUNCE_INTERFACE_SUCCESS:
      return {
        ...state,
        activeInterface: {
          interface_items: action.payload.unbounce_interface.interface_items,
        },
      };

    default:
      return state;
  }
}
